import { mergeMap } from 'rxjs/operators';
import { ConfigurationService } from '../../../shared/services/configuration.service';
import { LookupService } from '../../../shared/services/lookup.service';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnnouncementLookupResolveService {
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    //TODO: load only reuqired lookups and configs
    return this.lookupService
      .loadAllLookups()
      .pipe(mergeMap((x) => this.configurationService.loadAllConfigs()));
  }

  constructor(
    private lookupService: LookupService,
    private configurationService: ConfigurationService
  ) {}
}
